if (!customElements.get("activity-indicator-wrapper")) {
  customElements.define(
    "activity-indicator-wrapper",
    class LocationSelectorWrapper extends HTMLElement {
      constructor() {
        super();
        this.countdownInterval,
          (this.elements = {
            timed: this.querySelector(".activity-indicator__endtime span"),
            copyCode: this.querySelector(".activity-indicator__code button"),
            tips: this.querySelector(".activity-indicator__tips"),
            detail: this.querySelector(".activity-indicator__detail"),
            close: this.querySelector(".activity-indicator__detail-close"),
          });
        if(this.elements.timed && this.elements.timed.dataset.time) {
          this.updateCountdown(this.elements.timed, this.elements.timed.dataset.time);
        }
        if(this.elements.copyCode) {
          this.elements.copyCode.addEventListener("click", () => this.copyCode());
        }
        this.elements.tips.addEventListener("click", () => {
          const tips_url = this.elements.tips.dataset.url;
          if (tips_url) {
            window.open(tips_url, "_blank");
          } else {
            this.showDetail();
          }
        });
        this.elements.close.addEventListener("click", () => this.hideDetail());
        window.addEventListener("beforeunload", () => {
          if (this.countdownInterval) {
            clearInterval(this.countdownInterval);
          }
        });
      }

      showDetail() {
        document.body.appendChild(this.elements.detail);
        this.elements.detail.classList.add("active");
      }

      hideDetail() {
        this.elements.detail.classList.remove("active");
      }

      copyCode() {
        const copyText = this.elements.copyCode.dataset.code;
        const copiedText = this.elements.copyCode.dataset.copied;
        const prevText = this.elements.copyCode.innerHTML;
        navigator.clipboard.writeText(copyText).then(() => {
          this.elements.copyCode.classList.add("copied");
          this.elements.copyCode.innerHTML = copiedText;
          setTimeout(() => {
            this.elements.copyCode.classList.remove("copied");
            this.elements.copyCode.innerHTML = prevText;
          }, 2000);
        });
      }

      updateCountdown(domElement, targetDateTime) {
        if (!targetDateTime || !domElement) {
          return;
        }
        const days_t = domElement.dataset.days;
        // 将目标时间日期转换为时间戳
        const targetTimestamp = new Date(targetDateTime).getTime();

        // 定义更新倒计时的函数
        const update = () => {
          // 获取当前时间的时间戳
          const currentTimestamp = Date.now();

          // 计算时间差（毫秒）
          const timeDifference = targetTimestamp - currentTimestamp;

          // 如果时间差小于等于0，说明倒计时结束
          if (timeDifference <= 0) {
            domElement.textContent = "00:00:00";
            return;
          }

          // 将时间差转换为天数、小时、分钟和秒数
          const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
          const remainingMillisecondsAfterDays = timeDifference % (1000 * 60 * 60 * 24);

          const hours = Math.floor(remainingMillisecondsAfterDays / (1000 * 60 * 60));
          const remainingMillisecondsAfterHours = remainingMillisecondsAfterDays % (1000 * 60 * 60);

          const minutes = Math.floor(remainingMillisecondsAfterHours / (1000 * 60));
          const remainingMillisecondsAfterMinutes = remainingMillisecondsAfterHours % (1000 * 60);

          const seconds = Math.floor(remainingMillisecondsAfterMinutes / 1000);

          // 更新DOM元素中的倒计时显示内容
          const daysText = days > 0 ? `${days} ${days_t} ` : "";
          const timeText = `${padZero(hours)}:${padZero(minutes)}:${padZero(seconds)}`;
          
          
          domElement.textContent = `${daysText}${timeText}`;
        };

        // 立即执行一次更新函数，初始化倒计时显示
        update();

        // 每隔1秒调用一次更新函数，实现实时更新
        this.countdownInterval = setInterval(update, 1000);

        // 辅助函数，用于在数字小于10时在前面补0
        function padZero(num) {
          return num < 10 ? "0" + num : num;
        }
      }
    }
  );
}
